import React, { FC, useMemo } from 'react';

import {ITableActionProps} from 'components/table/action';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {useAppSelector} from 'store/config/hooks';

import {ButtonActionForProjectInvestmentRows} from './button-action-for-project-investment-rows';

interface IProjectInvestmentInfoDeleteRowsModalOpenerProps extends ITableActionProps {
}

export const ProjectInvestmentInfoDeleteRowsModalOpener: FC<IProjectInvestmentInfoDeleteRowsModalOpenerProps> = ({
  wrapper,
  meta,
  entityName,
  ...props
}: IProjectInvestmentInfoDeleteRowsModalOpenerProps) => {
  const tableData = useAppSelector(selectTableEntityData(entityName || ''));
  const selectedRows = useMemo(() => tableData?.selectedRows || [], [tableData?.selectedRows]);


  const activeRows = useMemo(() => selectedRows
      .filter(row => row.active)
      .map(row => row.investProjectId?.toString() || ''), [selectedRows]);

    return (
        <ButtonActionForProjectInvestmentRows
            wrapper={wrapper}
            meta={meta}
            entityName={entityName}
            activeRows={activeRows.map(row => row?.toString())}
            {...props}
        />
    )
};